<mat-spinner
	[diameter]="diameter"
	[strokeWidth]="strokeWidth ?? diameter / 10"
></mat-spinner>
<span class="label" *ngIf="label" [translate]="label"></span>
